/** Extrae mensaje legible de respuestas de error Axios del backend SmileWEB. */
export const getApiErrorMessage = (error, fallback = 'Ocurrió un error inesperado.') => {
    const data = error?.response?.data;
    if (!data) {
        return error?.message || fallback;
    }
    if (typeof data.message === 'string' && data.message.trim()) {
        return data.message;
    }
    if (typeof data.error === 'string' && data.error.trim()) {
        return data.error;
    }
    if (data.errors && typeof data.errors === 'object') {
        const first = Object.values(data.errors)[0];
        if (Array.isArray(first) && first[0]) return String(first[0]);
        if (typeof first === 'string') return first;
    }
    return error?.message || fallback;
};

export const isConsecutivoEgresoDuplicado = (error) => {
    const data = error?.response?.data;
    if (data?.codigo === 'consecutivo_egreso_duplicado') return true;
    const texto = getApiErrorMessage(error, '').toLowerCase();
    return texto.includes('consecutivo de egreso') || texto.includes('ya existe un egreso con el número');
};
